import { lego } from './lego';
import { colors } from './colors';
import icons from '../images/icons';
import { breakPoints } from './breakPoints';

export default { breakPoints, colors, lego, icons };
